// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2JUsv","noInteraction":"EventWrapper_noInteraction__XVnR_","pointerPassthrough":"EventWrapper_pointerPassthrough__2CH9Q"};